"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationModal = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button/Button");
var Modal_1 = require("../Modal/Modal");
var MultiStep_1 = require("../MultiStep");
require("./AuthorizationModal.css");
function AuthorizationModal(_a) {
    var currentStep = _a.currentStep, header = _a.header, steps = _a.steps, onClose = _a.onClose;
    return (react_1.default.createElement(Modal_1.Modal, { open: true, onClose: onClose, "data-testid": "authorization-modal", className: "authorization-modal-container" },
        react_1.default.createElement("div", { className: "authorization-modal" },
            react_1.default.createElement(Button_1.Button, { basic: true, "aria-label": "Close", className: "close-button", onClick: onClose }),
            react_1.default.createElement("h1", { className: "authorization-header" }, header),
            react_1.default.createElement(MultiStep_1.MultiStep, { currentStep: currentStep, steps: steps }))));
}
exports.AuthorizationModal = AuthorizationModal;
